
export class AboutModel {

  public name: string;
  public surname: string;
  public address: string;
  public email: string;
  public summary: string;
  public linkedin: string;
  public twitter: string;
  public github: string;
  public docker: string;

  constructor (name: string, surname: string, address: string, email: string, summary: string, linkedin: string,
               twitter: string, github: string, docker: string ) {
    this.name = name;
    this.surname = surname;
    this.address = address;
    this.email = email;
    this.summary = summary;
    this.linkedin = linkedin;
    this.twitter = twitter;
    this.github = github;
    this.docker = docker;
  }

}
